"use strict";
const { orderStates } = require('./order.const');
const orderStatesForDropShipSupplier = [
    orderStates.approvedByDropshipSupplier,
    orderStates.inWarehouseProcess,
    orderStates.readyForShipping,
    orderStates.enRoute,
];
const orderStatesForStandAloneSupplier = [
    orderStates.delivered,
    orderStates.inWarehouseProcess,
    orderStates.readyForShipping,
    orderStates.enRoute,
    orderStates.waitingForRestock,
    orderStates.waitingForAdvancePayment,
    orderStates.approved,
    orderStates.received,
    orderStates.created,
];
const openOrderStates = [
    orderStates.approved,
    orderStates.approvedByDropshipSupplier,
    orderStates.inWarehouseProcess,
    orderStates.readyForShipping,
    orderStates.enRoute,
];
const alreadyOrderedStates = [
    orderStates.received,
    orderStates.waitingForRestock,
    orderStates.waitingForAdvancePayment,
    orderStates.approved,
    orderStates.approvedByDropshipSupplier,
    orderStates.inWarehouseProcess,
    orderStates.readyForShipping,
    orderStates.enRoute,
];
const orderAlreadySentToWarehouseState = [
    orderStates.approved,
    orderStates.readyForShipping,
    orderStates.inWarehouseProcess,
    orderStates.enRoute,
    orderStates.delivered,
];
const acceptableCancelStates = [
    orderStates.draft,
    orderStates.created,
    orderStates.received,
    orderStates.approved,
    orderStates.waitingForRestock,
    orderStates.approvedByDropshipSupplier,
];
const acceptableCancelStatesForStandAloneOrder = [
    ...acceptableCancelStates,
    orderStates.inWarehouseProcess,
    orderStates.readyForShipping,
    orderStates.enRoute,
    orderStates.delivered,
    orderStates.returned,
];
const noMergeStates = [
    orderStates.inWarehouseProcess,
    orderStates.readyForShipping,
    orderStates.enRoute,
    orderStates.delivered,
    orderStates.invoiced,
];
module.exports = {
    openOrderStates,
    alreadyOrderedStates,
    orderStatesForDropShipSupplier,
    orderAlreadySentToWarehouseState,
    orderStatesForStandAloneSupplier,
    acceptableCancelStates,
    acceptableCancelStatesForStandAloneOrder,
    noMergeStates,
};
